import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import commonFuncSlice from "./slices/commonFun";
const selectProposalStore = configureStore({
  reducer: {
    authSlice: authSlice.reducer,
    commonFunc: commonFuncSlice.reducer,
  },
});

export default selectProposalStore;
